import React from "react";
import { motion } from "framer-motion";

export default function FrontBanner() {
  return (
    <div className="overflow-hidden">
      <div className="container-fluid bg-primary px-0 px-md-5 mb-2w" style={{ minHeight: 'calc(100vh - 72px)', display: 'flex', alignItems: 'center' }}>
        <div className="align-items-center px-3 bannerContainer" style={{
          display: "flex",
          flexWrap: 'wrap'
        }}>
          <motion.div 
            className="col-lg-6 text-center text-lg-left"
            initial={{ opacity: 0, x: -100 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1, ease: "easeOut" }}
          >
            <motion.h4 
              className="text-white mb-4 mt-5 mt-lg-0"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.5, duration: 0.8 }}
            >
              Inspiration, Motivation and Education
            </motion.h4>
            <motion.h1 
              className="display-4 font-weight-bold text-white"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.8, duration: 0.8 }}
            >
              Better Education For A Better World.
            </motion.h1>
            <motion.p 
              className="text-white mb-4"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 1.1, duration: 0.8 }}
            >
              Any successful career starts with good education. Together with us
              you will have deeper knowledge of the subjects that will be
              especially useful for you when climbing the career ladder.
            </motion.p>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 1.4, duration: 0.5 }}
            >
              <a href="/" className="btn btn-secondary mt-1 py-3 px-5 banner-btn">
                Learn More
              </a>
            </motion.div>
          </motion.div>
          <motion.div 
            className="col-lg-6 text-center text-lg-right"
            initial={{ opacity: 0, scale: 0.8, rotate: -2 }}
            animate={{ opacity: 1, scale: 1, rotate: 0 }}
            transition={{ duration: 1.2, ease: "easeOut" }}
          >
            <img className="img-fluid bannerImage" src={require('../assets/banner.jpg')} alt="" />
          </motion.div>
        </div>
      </div>
    </div>
  );
}
